import { Button } from "common/buttons/Button";
import { Box } from "common/components/Box";
import React, { Dispatch, SetStateAction, useState } from "react";

interface ContentProps {
  cancel(): void;
  complete(): void;
  setState(content: any): void;
}

interface Props {
  buttonText: string;
  content: React.ComponentType<ContentProps>;
  onUpdated(): void;
  state?: Dispatch<SetStateAction<any>>;
}

export const CreateContentFooterBox: React.FC<
  React.PropsWithChildren<Props>
> = ({ buttonText, content: Content, onUpdated, state }) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <>
      {!isOpen && (
        <Box centeredContent>
          <Button
            onClick={() => {
              setOpen(!isOpen);
            }}
          >
            {buttonText}
          </Button>
        </Box>
      )}
      {isOpen && (
        <Content
          cancel={() => {
            setOpen(false);
          }}
          complete={() => {
            onUpdated();
            setOpen(false);
          }}
          setState={(content) => {
            if (state) state(content);
          }}
        />
      )}
    </>
  );
};
